import { Paths } from "@/modules/beneficiary/common/enum";
import { BeneficiariesPage, CreateBeneficiaryPage } from "@/modules/beneficiary/pages";
import { FeatureToggle } from "@/shared/common/enums";
import { FeatureToggleRoute } from "@/shared/components";
import { Layout } from "@/shared/layout";
import type { RouteObject } from "react-router-dom";

export const beneficiaryRoutes: RouteObject = {
  path: Paths.Beneficiaries,
  element: <Layout/>,
  handle: {
    breadcrumb: () => ({ key: "breadcrumb.beneficiaries" }),
  },
  children: [
    {
      path: "",
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isBeneficiaryAvailable}
          element={<BeneficiariesPage/>}
        />
      )
    },
    {
      path: Paths.CreateBeneficiary,
      element: (
        <FeatureToggleRoute
          featureFlag={FeatureToggle.isBeneficiaryAvailable}
          element={<CreateBeneficiaryPage/>}
        />
      ),
      handle: {
        breadcrumb: () => ({ key: "breadcrumb.createBeneficiary" })
      }
    },
  ],
};
